/** What a paginated list does with the scroll position when the visible rows are replaced (a page
 *  change, a page-size change, a column sort). 'top' brings the table back to the top of the
 *  scrollable area -- the default, since the rows under the cursor are no longer the ones the reader
 *  was looking at. 'keep' leaves the viewport exactly where it was (the behaviour before the setting
 *  existed), for a user who prefers to stay put. */
export type ListScrollPref = 'top' | 'keep';

export const LIST_SCROLL_KEY = 'display.listScroll';

/** The default: anything that isn't an explicit 'keep' scrolls back to the top. Deliberately
 *  asymmetric -- a user who never touched the setting (and a corrupt/missing stored value) gets the
 *  scroll-to-top behaviour, and only a deliberate opt-out turns it off. */
export function coerceListScroll(v: unknown): ListScrollPref {
  return v === 'keep' ? 'keep' : 'top';
}
